import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilterClean = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.30856 4.20656C1.13814 4.42384 1.17613 4.73814 1.39341 4.90856L3.74987 6.75681C3.77298 6.79225 3.79826 6.82656 3.82572 6.8595L8.90973 13.0548V15.2495C8.90973 15.5551 9.02085 15.8051 9.24311 15.9718L11.0211 17.3053C11.2989 17.4998 11.6601 17.5276 11.9657 17.3887C12.2713 17.2498 12.4658 16.9442 12.4658 16.583V13.593L17.1303 17.2516C17.3476 17.422 17.6619 17.384 17.8323 17.1667L18.2643 16.6159C18.4347 16.3987 18.3968 16.0844 18.1795 15.9139L2.44257 3.57092C2.22529 3.4005 1.91099 3.43849 1.74057 3.65577L1.30856 4.20656ZM17.522 6.8595L14.4996 10.5627L7.44045 5.02592H16.6885C17.1053 5.02592 17.4942 5.27596 17.6887 5.6649C17.8554 6.05384 17.7998 6.52612 17.522 6.8595Z",
		fillRule: "evenodd",
		clipRule: "evenodd",
		fill: "#0D2976"
	})
});
export default SvgFilterClean;
